<app-operations-shell area="admin" [bare]="router.url.startsWith('/admin/login')">
  <router-outlet></router-outlet>
</app-operations-shell>
